import type { FC, SVGAttributes } from 'react';

export interface IconPriceProps extends SVGAttributes<SVGSVGElement> {
  className?: string;
}

export const IconPrice: FC<IconPriceProps> = (props) => {
  return (
    <svg
      {...props}
      width='454'
      height='48'
      viewBox='0 0 454 48'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M29.7913 45.1798V37.2268H0.666748V0H6.69643V31.8684H24.8993V0H30.9289V31.8684H35.6503V45.1798H29.7913Z'
        fill='#C4C4C4'
      />
      <path
        d='M66.0742 25.3255H45.2548C45.9943 29.8378 49.5779 32.6016 54.3562 32.6016C57.2573 32.6016 59.9877 31.53 62.4906 29.3302L65.3348 33.3913C62.1493 36.3807 58.4518 37.8472 54.1855 37.8472C45.653 37.8472 39.1682 31.5864 39.1682 23.4078C38.9975 15.4548 45.7098 8.74266 53.6167 8.91187C61.0116 8.91187 66.5293 14.3831 66.5293 21.6028C66.5293 22.7873 66.3587 24.0282 66.0742 25.3255ZM45.3685 20.7004H60.5565C60.4996 16.47 57.3141 13.9318 53.3892 13.9318C49.4642 13.9318 46.2787 16.5828 45.3685 20.7004Z'
        fill='#C4C4C4'
      />
      <path
        d='M73.43 37.2268V9.53231H79.4597V20.1363H91.4622V9.53231H97.435V37.2268H91.4622V25.2691H79.4597V37.2268H73.43Z'
        fill='#C4C4C4'
      />
      <path
        d='M128.333 20.4747V37.2268H122.758V34.1246C120.71 36.5499 117.639 37.8472 113.827 37.8472C107.968 37.8472 104.1 34.6322 104.1 29.8378C104.1 25.0435 108.082 21.9412 114.396 21.9412H122.303V20.1363C122.303 16.3008 120.141 14.2139 116.33 14.2139C113.202 14.2139 110.926 15.5676 108.594 18.3314L105.124 14.8343C107.911 10.8296 112.064 8.91187 116.899 8.91187C123.782 8.91187 128.333 13.0294 128.333 20.4747ZM122.303 26.7356V26.228H115.136C111.95 26.228 110.187 27.3561 110.187 29.6122C110.187 31.9248 112.178 33.2785 115.079 33.2785C119.118 33.2785 122.303 30.5147 122.303 26.7356Z'
        fill='#C4C4C4'
      />
      <path
        d='M152.645 37.2268V9.53231H176.366V37.2268H170.336V14.6651H158.675V37.2268H152.645Z'
        fill='#C4C4C4'
      />
      <path
        d='M183.322 23.3514C183.151 15.3984 190.034 8.79906 198.055 8.91187C206.189 8.74266 213.072 15.5112 212.902 23.3514C213.072 31.1915 206.189 38.0165 198.055 37.8472C190.034 38.0165 183.151 31.1915 183.322 23.3514ZM206.758 23.4078C206.758 18.275 202.947 14.3267 198.112 14.3267C193.163 14.3267 189.409 18.275 189.409 23.4078C189.409 28.5405 193.163 32.376 198.055 32.376C203.004 32.376 206.758 28.4277 206.758 23.4078Z'
        fill='#C4C4C4'
      />
      <path
        d='M255.943 29.161C255.943 34.6322 251.79 37.8472 244.964 37.8472C240.072 37.8472 236.261 36.0987 233.587 32.6016L237.228 29.0482C239.048 31.2479 241.324 32.6016 244.68 32.6016C248.093 32.6016 250.027 31.0787 250.027 28.7662C250.027 26.5664 248.206 25.1563 244.964 25.1563H241.722V20.4183H244.793C247.353 20.4183 248.775 19.2338 248.775 17.2597C248.775 15.3984 247.239 14.1575 244.566 14.1575C241.437 14.1575 239.503 15.2855 237.74 17.2597L234.099 13.7062C236.431 10.7732 240.243 8.91187 244.85 8.91187C250.937 8.91187 254.634 11.7885 254.634 16.7521C254.634 19.2338 253.61 21.2644 251.619 22.6181C254.407 23.9718 255.943 26.3972 255.943 29.161Z'
        fill='#C4C4C4'
      />
      <path
        d='M285.096 20.4747V37.2268H279.522V34.1246C277.474 36.5499 274.402 37.8472 270.591 37.8472C264.732 37.8472 260.864 34.6322 260.864 29.8378C260.864 25.0435 264.846 21.9412 271.16 21.9412H279.067V20.1363C279.067 16.3008 276.905 14.2139 273.094 14.2139C269.965 14.2139 267.69 15.5676 265.358 18.3314L261.888 14.8343C264.675 10.8296 268.828 8.91187 273.663 8.91187C280.546 8.91187 285.096 13.0294 285.096 20.4747ZM279.067 26.7356V26.228H271.899C268.714 26.228 266.951 27.3561 266.951 29.6122C266.951 31.9248 268.941 33.2785 271.843 33.2785C275.881 33.2785 279.067 30.5147 279.067 26.7356Z'
        fill='#C4C4C4'
      />
      <path
        d='M293.466 37.2268V9.53231H317.186V37.2268H311.157V14.6651H299.496V37.2268H293.466Z'
        fill='#C4C4C4'
      />
      <path
        d='M354.917 23.3514C354.917 31.6428 349.115 37.8472 341.208 37.8472C337.397 37.8472 334.097 36.3807 331.879 33.8425V47.3796H325.906V9.53231H331.481V13.4242C333.529 10.5476 337.112 8.91187 341.208 8.91187C349.115 8.91187 354.917 15.1727 354.917 23.3514ZM348.773 23.4078C348.773 18.1058 345.076 14.3267 340.241 14.3267C335.861 14.3267 331.822 17.3161 331.822 23.3514C331.822 29.443 335.861 32.4324 340.241 32.4324C345.019 32.4324 348.773 28.7098 348.773 23.4078Z'
        fill='#C4C4C4'
      />
      <path
        d='M360.028 23.3514C359.858 15.3984 366.741 8.79906 374.761 8.91187C382.896 8.74266 389.779 15.5112 389.608 23.3514C389.779 31.1915 382.896 38.0165 374.761 37.8472C366.741 38.0165 359.858 31.1915 360.028 23.3514ZM383.465 23.4078C383.465 18.275 379.653 14.3267 374.818 14.3267C369.869 14.3267 366.115 18.275 366.115 23.4078C366.115 28.5405 369.869 32.376 374.761 32.376C379.71 32.376 383.465 28.4277 383.465 23.4078Z'
        fill='#C4C4C4'
      />
      <path
        d='M394.692 23.3514C394.521 15.3984 401.461 8.79906 409.482 8.91187C414.658 8.91187 418.811 11.3372 421.257 15.342L417.047 18.6134C415.056 15.7932 412.554 14.3831 409.539 14.3831C404.533 14.3831 400.779 18.3314 400.779 23.3514C400.779 28.4277 404.533 32.376 409.539 32.376C412.497 32.376 415 30.9659 417.047 28.2021L421.257 31.4172C418.754 35.4219 414.544 37.8472 409.482 37.8472C401.234 37.8472 394.692 31.4172 394.692 23.3514Z'
        fill='#C4C4C4'
      />
      <path
        d='M447.296 9.53231H453.667L440.072 40.3854C437.739 45.631 434.611 48 429.832 48C428.297 48 426.761 47.8308 425.225 47.436V42.416C426.988 42.5852 428.069 42.6416 428.524 42.6416C431.311 42.6416 433.245 41.6827 434.611 38.5805L435.748 35.9859L424.599 9.53231H431.027L439.048 29.6686L447.296 9.53231Z'
        fill='#C4C4C4'
      />
    </svg>
  );
};
